import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  computed,
  DestroyRef,
  ElementRef,
  inject,
} from '@angular/core';
import { BreadcrumbsComponent } from '../breadcrumb/breadcrumbs.component';
import { MatIconButton } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';
import { AuthService } from '../auth/auth.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIcon } from '@angular/material/icon';
import { MindRecComponent } from '../../shared/components/mind-rec/mind-rec.component';
import { ServerTimeService } from '../server-time.service';
import { MatTooltip } from '@angular/material/tooltip';
import { AddDeltaToTimeInZonePipe } from '../../shared/pipes/add-delta-to-time.pipe';

@Component({
  selector: 'app-nav-menu',
  imports: [
    BreadcrumbsComponent,
    MatIcon,
    MatIconButton,
    MatMenuModule,
    MatDividerModule,
    TranslocoDirective,
    MindRecComponent,
    MatTooltip,
    AddDeltaToTimeInZonePipe,
  ],
  templateUrl: './nav-menu.component.html',
  styleUrl: './nav-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavMenuComponent {
  private readonly authService = inject(AuthService);
  private readonly serverTimeService = inject(ServerTimeService);
  private readonly el = inject(ElementRef);
  protected readonly userName = computed(() => this.authService.user()?.name);
  protected readonly serverUtcTime = this.serverTimeService.serverUtcTime;
  private readonly onScroll = (): void => this.updateVars();

  constructor() {
    const destroyRef = inject(DestroyRef);
    afterNextRender(() => {
      window.addEventListener('scroll', this.onScroll, { passive: true });
      destroyRef.onDestroy(() => window.removeEventListener('scroll', this.onScroll));
    });
  }

  private updateVars(): void {
    const progress = Math.min(window.scrollY / 50, 1);
    const host = this.el.nativeElement;
    host.style.setProperty('--background-opacity', `${progress * 30}%`);
    host.style.setProperty('--background-blur', `${progress * 30}px`);
    host.style.setProperty('--border-opacity', `${progress * 20}%`);
  }

  protected signOut(): void {
    this.authService.logout();
  }

  protected openProfile(): void {
    this.authService.goToAccount();
  }
}
